import React from 'react';

function StatusBadge({ status }) {
  const icons = {
    active: '✓',
    challenged: '⚖',
    blocked: '✕',
    pending: '◷'
  };

  const classes = {
    active: 'status-active',
    challenged: 'status-challenged',
    blocked: 'status-blocked',
    pending: 'status-pending'
  };

  return (
    <span className={`status-badge ${classes[status]}`}>
      <span>{icons[status]}</span>
      <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
    </span>
  );
}

export default StatusBadge;
